import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { InputFieldV2 as InputField, ButtonV2 as Button, Link, Banner } from '@zola/zola-ui';

import {
  getUserContext as getUserContextAction,
  identifyGuestUser as identifyGuestUserAction,
} from 'actions/UserActions';

import { createAccount } from 'paper/utils/account';

import styles from './styles.module.less';

const SimpleSignUpForm = ({
  closeModal,
  closeCallback,
  onLogIn,
  businessUnitComponent,
  fetchUserContext,
  onExternalSignUp,
  isGuest,
  shouldTrackOnboarding = true,
  handleIdentifyGuestUser,
}) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [errors, setErrors] = useState(null);
  const [signUpForm, setSignUpForm] = useState({
    ownerDetails: { hasNoPartner: true },
    ownerAccount: {},
  });
  const [creatingAccount, setCreatingAccount] = useState(false);

  useEffect(() => {
    // Identify segment guest user
    handleIdentifyGuestUser();
  }, []);

  useEffect(() => {
    const isFormFullyFilled =
      signUpForm.ownerDetails.fullName &&
      signUpForm.ownerAccount.email &&
      signUpForm.ownerAccount.password;
    setIsDisabled(!isFormFullyFilled);
  }, [signUpForm]);

  const handleFieldUpdate = (type, key, value) => {
    setSignUpForm({
      ...signUpForm,
      [type]: {
        ...signUpForm[type],
        [key]: value,
      },
    });
  };

  const handleLogIn = () => {
    if (closeModal instanceof Function) {
      closeModal();
    }
    setTimeout(() => {
      window.zolaNav.openLoginModal({
        loginCallback: () => {
          fetchUserContext().then(() => {
            onLogIn();
          });
        },
        signupLinkCallback: () => onExternalSignUp(),
        closeCallback: () => {
          if (closeCallback instanceof Function) {
            return closeCallback();
          }

          return null;
        },
      });
    }, 50);
  };

  const onSubmit = e => {
    e.preventDefault();

    if (!creatingAccount) {
      setCreatingAccount(true);
      createAccount({
        accountDetails: signUpForm.ownerAccount,
        weddingDetails: signUpForm.ownerDetails,
        businessUnitComponent,
        isGuest,
        shouldTrackOnboarding,
      }).then(result => {
        setCreatingAccount(false);
        if (result.errors) {
          setErrors(result.errors);
          return;
        }

        fetchUserContext().then(() => {
          if (closeModal instanceof Function) {
            closeModal();
          }
          onLogIn();
        });
      });
    }
  };

  return (
    <>
      <h1 className={styles.title}>Sign Up</h1>
      <p className={styles.text}>Create an account so we can magically fill in your cards!</p>
      <p className={styles.text}>
        Already have an account?{' '}
        <Link role="button" onClick={handleLogIn}>
          Log In
        </Link>
      </p>
      {errors && errors.weddingDetails && (
        <div className={styles.errorWrapper}>
          <Banner type="error">{errors.weddingDetails}</Banner>
        </div>
      )}
      {errors && errors.account && (
        <div className={styles.errorWrapper}>
          <Banner type="error">{errors.account}</Banner>
        </div>
      )}
      <form onSubmit={onSubmit}>
        <div className={styles.fieldWrapper}>
          <InputField
            type="text"
            label="Your Full Name"
            value={signUpForm.fullName}
            onChange={e => handleFieldUpdate('ownerDetails', 'fullName', e.target.value)}
            isRequired
          />
        </div>
        <div className={styles.fieldWrapper}>
          <InputField
            type="email"
            label="Email"
            placeholder="user@email.com"
            value={signUpForm.email}
            onChange={e => handleFieldUpdate('ownerAccount', 'email', e.target.value)}
            isRequired
          />
        </div>
        <div className={styles.fieldWrapper}>
          <InputField
            type="password"
            label="Password"
            value={signUpForm.password}
            onChange={e => handleFieldUpdate('ownerAccount', 'password', e.target.value)}
            isRequired
          />
        </div>
        <div className={styles.fieldWrapper}>
          <Button className={styles.cta} disabled={isDisabled} type="submit">
            Create Account
          </Button>
        </div>
      </form>
    </>
  );
};

SimpleSignUpForm.propTypes = {
  closeModal: PropTypes.func,
  closeCallback: PropTypes.func,
  isGuest: PropTypes.bool,
  onLogIn: PropTypes.func,
  shouldTrackOnboarding: PropTypes.bool,
  businessUnitComponent: PropTypes.string.isRequired,
  fetchUserContext: PropTypes.func,
  onExternalSignUp: PropTypes.func,
  handleIdentifyGuestUser: PropTypes.func,
};

export default connect(null, {
  fetchUserContext: getUserContextAction,
  handleIdentifyGuestUser: identifyGuestUserAction,
})(SimpleSignUpForm);



// WEBPACK FOOTER //
// ./src/paper/components/SimpleSignUpForm/SimpleSignUpForm.jsx